import React from 'react';
interface ButtonProps extends React.ButtonHTMLAttributes<HTMLButtonElement> {
  isLoading?: boolean;
  loadingText?: string;
  variant?: 'primary' | 'secondary';
}
export function Button({
  children,
  isLoading,
  loadingText = 'Loading...',
  variant = 'primary',
  className = '',
  ...props
}: ButtonProps) {
  const baseStyles = 'w-full h-[52px] rounded-btn font-medium transition-all duration-300 flex items-center justify-center active:scale-[0.97]';
  const variants = {
    primary: 'bg-primary text-white hover:shadow-elevated',
    secondary: 'bg-secondary text-text-primary hover:bg-border'
  };
  return <button className={`${baseStyles} ${variants[variant]} ${isLoading || props.disabled ? 'opacity-70 cursor-not-allowed' : ''} ${className}`} disabled={isLoading || props.disabled} {...props} data-id="element-203" data-mp="288uzawo9rabe">
      {isLoading ? <div className="flex items-center space-x-2" data-id="element-204" data-mp="30sbf2eoy9oe9">
          <svg className="animate-spin h-5 w-5 text-white" xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" data-id="element-205" data-mp="2vyp8935gweqd">
            <circle className="opacity-25" cx="12" cy="12" r="10" stroke="currentColor" strokeWidth="4" data-id="element-206" data-mp="i0tfsqfqthfz"></circle>
            <path className="opacity-75" fill="currentColor" d="M4 12a8 8 0 018-8V0C5.373 0 0 5.373 0 12h4zm2 5.291A7.962 7.962 0 014 12H0c0 3.042 1.135 5.824 3 7.938l3-2.647z" data-id="element-207" data-mp="89p35xdji8ob"></path>
          </svg>
          <span data-id="element-208" data-mp="3gi5qj26h89qx">{loadingText}</span>
        </div> : children}
    </button>;
}